import {
  createProgressiveRequestHandler,
  createRequestHandler,
} from "../utils/requestHandlers";

import { MediaBaseRouteDelete } from "./media";
import { cfAPI } from "../api";
import { createFormData } from "../utils/onCreateFormData";
import { createProgressHandler } from "../utils/createProgressHandler";

// Action Types
const ABOUT_REQUEST = "ABOUT_REQUEST";
const ABOUT_ERROR = "ABOUT_ERROR";
const ABOUTS_FETCH = "ABOUTS_FETCH";
const ABOUT_FETCH = "ABOUT_FETCH";
const ABOUT_CREATE = "ABOUT_CREATE";
const ABOUT_DELETE_IMAGE = "ABOUT_DELETE_IMAGE";
const ABOUT_EDIT = "ABOUT_EDIT";
const ABOUT_DELETE = "ABOUT_DELETE";

// Download Action Types for about
const ABOUT_DOWNLOAD_START = "ABOUT_DOWNLOAD_START";
const ABOUT_DOWNLOAD_UPDATE = "ABOUT_DOWNLOAD_UPDATE";
const ABOUT_DOWNLOAD_FINISH = "ABOUT_DOWNLOAD_FINISH";

const BaseRoute = "cfwebapi/api/v1/misc";

// Reusable action types object for consistency
const actionTypes = {
  fetches: {
    request: ABOUT_REQUEST,
    success: ABOUTS_FETCH,
    error: ABOUT_ERROR,
  },
  fetch: { request: ABOUT_REQUEST, success: ABOUT_FETCH, error: ABOUT_ERROR },
  create: { request: ABOUT_REQUEST, success: ABOUT_CREATE, error: ABOUT_ERROR },
  update: { request: ABOUT_REQUEST, success: ABOUT_EDIT, error: ABOUT_ERROR },
  delete: { request: ABOUT_REQUEST, success: ABOUT_DELETE, error: ABOUT_ERROR },
  deleteImage: {
    request: ABOUT_REQUEST,
    success: ABOUT_DELETE_IMAGE,
    error: ABOUT_ERROR,
  },
  download: {
    request: ABOUT_REQUEST,
    start: ABOUT_DOWNLOAD_START,
    update: ABOUT_DOWNLOAD_UPDATE,
    finish: ABOUT_DOWNLOAD_FINISH,
    success: ABOUTS_FETCH,
    error: ABOUT_ERROR,
  },
};

const INITIAL_STATE = {
  loading: false,
  success: false,
  abouts: [],
  about: {},
  error: "",
  downloadProgress: 0,
  isDownloading: false,
};

// // Reusable handler for form data creation
// const createFormData = (values) => {
//   const formData = new FormData();
//   const finalData = _.omit(
//     {
//       ...values,
//       mediaType: "IMAGE",
//     },
//     "files"
//   );
//   if (values.files) {
//     for (const file of values.files) {
//       formData.append("files", file.file);
//     }
//   }
//   const blob = new Blob([JSON.stringify(finalData)], {
//     type: "application/json",
//   });
//   formData.append("data", blob);
//   return formData;
// };

// Actions using the new handlers
export const FetchAbout = () => async (dispatch) => {
  await createProgressiveRequestHandler(
    dispatch,
    () =>
      cfAPI.get(BaseRoute, {
        onDownloadProgress: createProgressHandler(
          dispatch,
          actionTypes.download.update,
          actionTypes.download.finish
        ),
      }),
    actionTypes.download,
    createProgressHandler
  );
};

export const CreateAbout = (values) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.post(BaseRoute, createFormData(values)),
    actionTypes.create,
    "Company Created"
  );
};

export const UpdateAbout = (id, values) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.patch(`${BaseRoute}/${id}`, createFormData(values)),
    actionTypes.update,
    "Update Successful"
  );
};

export const DeleteAboutPicture = (name, fileName) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.delete(MediaBaseRouteDelete(name, fileName)),
    actionTypes.deleteImage,
    "Image Deleted"
  );
};

export const DeleteAbout = (values) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.delete(`${BaseRoute}/${values.id}`),
    actionTypes.delete,
    "Delete Successful"
  );
};

// Reducer with toasts removed and state logic updated
export const AboutReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ABOUT_DOWNLOAD_START:
      return { ...state, isDownloading: true, downloadProgress: 0 };
    case ABOUT_DOWNLOAD_UPDATE:
      return { ...state, downloadProgress: action.payload };
    case ABOUT_DOWNLOAD_FINISH:
      return { ...state, isDownloading: false, downloadProgress: 100 };
    case ABOUT_REQUEST:
      return { ...state, loading: true };
    case ABOUTS_FETCH:
      return { ...state, loading: false, error: "", abouts: action.payload };
    case ABOUT_FETCH:
      return { ...state, loading: false, error: "", about: action.payload };
    case ABOUT_CREATE:
      return {
        ...state,
        loading: false,
        error: "",
        success: true,
        abouts: [...state.abouts, action.payload],
      };
    case ABOUT_EDIT:
      const updatedList = state.abouts.map((aboutItem) =>
        aboutItem.id === action.payload.id ? action.payload : aboutItem
      );
      return {
        ...state,
        loading: false,
        error: "",
        success: true,
        about: action.payload,
        abouts: updatedList,
      };
    case ABOUT_DELETE:
      const filteredList = state.abouts.filter(
        (aboutItem) => aboutItem.id !== action.payload.id
      );
      return {
        ...state,
        loading: false,
        error: "",
        success: true,
        abouts: filteredList,
      };
    case ABOUT_DELETE_IMAGE:
      return {
        ...state,
        loading: false,
        error: "",
        success: true,
        about: action.payload,
      };
    case ABOUT_ERROR:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
